import React from 'react';
import { Switch } from "antd-mobile";
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import { MemberDiscount } from 'src/common/member-discount/MemberDiscount';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import './TransferPage.less';

export default class TransferPage extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '当面付'
    },
    isShowNoJoinPrice: false,
    appTitle: '',
    franchisee: '', // 子店id
    balanceState: false, // 储值的状态
    storeState: true, // 店铺优惠的状态
    totalDiscountPrice: '',
    totalPayment: '',
    inputPrice: '', // 输入的金额
    oldInputPrice: '', // 上一次输入的金额
    noJoinPrice: '', // 不参与优惠金额
    oldNoJoinPrice: '', // 上一次不参与优惠金额
    requesting: false,
    transferConfig: {}, // 当面付配置信息
    userInfo: {}, // 会员信息
    vipCardInfo: {
      // 会员卡信息
      isShow: false,
      logo:
        'cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/transfer/default-vip-card-logo.png'
    },
    memberDiscount: [], // 会员优惠
    aloneBenefitState: 0, // 唯一的会员优惠的状态 0->不使用 | 1->使用
    selectedBenefit: {}, // 选中的会员优惠
    storeBenefitInfo: { discount_price: '0.00' }, // 店铺优惠
    useBalancePrice: '0.00', // 储值使用金额
    currentStoreBenefitInfo: {}, // 当前店铺满减活动
    storeBenefitActivityList: [], // 店铺优惠列表
    isShowPriceLimitTip: false, // 是否显示价格限制提示
    combineBenefit: {}, // 自定义优惠
    combineState: {
      // 自定义优惠的使用状态 0->不使用 | 1->使用
      vip: 0,
      coupon: 0,
      integral: 0
    },
    combineEnable: {
      // 自定义优惠的可用状态 0->不可用 | 1->可用
      vip: 0,
      coupon: 0,
      integral: 0
    },
    balanceItemInfo: [], // 储值项（用于充值）
    balancePayLoading: false, // 储值充值loading
    remark: '', // 备注
    inputState: 0, // 输入的状态 0->用户手动输入 1->扫码输入（关联金额） 2->扫码输入（关联订单）
    relatedOrderInfo: '', // 关联订单的数据 id、优惠信息
    benefitType: {
      vip: '会员卡',
      paid_vip: '会员卡',
      vip_benefit_day: '会员卡',
      coupon: '优惠券',
      integral: '积分'
    },
    relatedData: {}, // 关联订单的相关数据
    isShowBalanceItem: false // 是否显示储值项
  }
  calculateReqNum = 0

  memberDiscountRef = React.createRef();

  componentWillMount(options = getCurrentPageQueryParams()) {
    let franchisee = options.franchisee || ''
    let scene = options.scene
    let appTitle = franchisee ? '' : app.getAppTitle()
    this.setData({
      appTitle: appTitle,
      franchisee: franchisee,
      userInfo: app.getUserInfo(),
      franchiseeIdInfo: {
        id: franchisee
      }
    })
    if (franchisee) {
      this.getAppShopByPage()
    }
    this.getBalanceData()
    this.getTransferOrderConfig(() => {
      if (scene) {
        this.getSceneData(scene)
      }
    })
    this.getCurrentStoreBenefitInfo()
    this.getStoreBenefitActivityList()
    this.getBalanceInfo()
  }

  resetData = isInit => {
    this.setData({
      userInfo: app.getUserInfo(),
      selectedBenefit: {},
      storeBenefitInfo: { discount_price: '0.00' },
      totalPayment: '',
      balanceState: false,
      aloneBenefitState: 0,
      remark: '',
      useBalancePrice: '0.00',
      combineState: {
        vip: 0,
        coupon: 0,
        integral: 0
      },
      storeState: true,
      combineBenefit: {},
      inputState: 0,
      relatedOrderInfo: '',
      isShowBalanceItem: false,
      relatedData: {},
      oldInputPrice: '',
      oldNoJoinPrice: '',
      requesting: false
    })
    if (isInit) {
      this.setData({
        inputPrice: '',
        noJoinPrice: ''
      })
    }
  }
  getTransferOrderConfig = callback => {
    app.sendRequest({
      url: '/index.php?r=AppTransferOrder/GetTransferOrderConfig',
      method: 'post',
      data: {
        sub_shop_app_id: this.data.franchisee
      },
      hideLoading: true,
      success: res => {
        const { data, status } = res
        if (status === 0) {
          const {
            get_vipcard_directly,
            vipcard_id,
            background_color,
            scan_mode,
            input_mode
          } = data
          data.background_color = background_color || '#FF7100'
          if (scan_mode === '1' && input_mode === '0') {
            this.scanPaymentCode()
          }
          if (get_vipcard_directly == 1 && vipcard_id && vipcard_id != 0) {
            this.vipCardInit(vipcard_id)
          }
          if (callback) {
            callback()
          }
          this.setData({
            transferConfig: data
          })
          this.resetCombineEnable()
        }
      }
    })
  }
  resetCombineEnable = () => {
    const {
      combine_benefit_enable,
      vip_card_benefit_enable,
      coupon_benefit_enable,
      integral_benefit_enable
    } = this.data.transferConfig
    this.setData({
      combineEnable: {
        vip:
          combine_benefit_enable == 1 && vip_card_benefit_enable == 1 ? 1 : 0,
        coupon:
          combine_benefit_enable == 1 && coupon_benefit_enable == 1 ? 1 : 0,
        integral:
          combine_benefit_enable == 1 && integral_benefit_enable == 1 ? 1 : 0
      }
    })
  }
  vipCardInit = id => {
    this.getEnableVipCardList(id, () => {
      app.sendRequest({
        url: '/index.php?r=AppShop/GetVIPCardInfo',
        data: {
          vip_id: id,
          sub_shop_app_id: this.data.franchisee
        },
        hideLoading: true,
        success: res => {
          const { status, data } = res
          if (status === 0) {
            this.getUserVipLevel(data[0])
          }
        }
      })
    })
  }
  getUserVipLevel = cardInfo => {
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPInfo',
      data: {
        sub_shop_app_id: this.data.franchisee
      },
      hideLoading: true,
      success: res => {
        const { data, status } = res
        if (status === 0) {
          const level = data.level ? data.level : 0
          const id = data.vip_id ? data.vip_id : 0
          if (level <= +cardInfo.level && id !== cardInfo.id) {
            cardInfo.isShow = true
            cardInfo.logo = cardInfo.logo || this.data.vipCardInfo.logo
            this.setData({
              vipCardInfo: cardInfo
            })
          }
        }
      }
    })
  }
  getEnableVipCardList = (id, callback) => {
    app.sendRequest({
      url: '/index.php?r=AppVipCard/GetEnableVipCardList',
      data: {
        sub_shop_app_id: this.data.franchisee
      },
      hideLoading: true,
      success: res => {
        const data = res.data || []
        data.forEach(val => {
          if (val.id === id) {
            callback()
          }
        })
      }
    })
  }
  getCurrentStoreBenefitInfo = () => {
    app.sendRequest({
      url: '/index.php?r=AppStoreBenefit/GetCurrentStoreBenefitInfo',
      method: 'post',
      data: {
        sub_shop_app_id: this.data.franchisee
      },
      hideLoading: true,
      success: res => {
        let { data, status } = res
        if (status === 0) {
          if (data) {
            data.rule_titles = data.rule_titles.map(rule => {
              rule = rule.replace('分阶段满减<br>', '')
              rule = rule.replace('阶段满减<br>', '')
              return rule
            })
          }
          this.setData({
            currentStoreBenefitInfo: data || {}
          })
        }
      }
    })
  }
  goToCouponDesc = () => {
    let pagePath =
      '/eCommerce/pages/couponDescription/couponDescription?franchisee=' +
      this.data.franchisee
    app.turnToPage(pagePath, false)
  }
  handleVipCard = () => {
    this.getCollectUserinfoConfig(() => {
      app.turnToPage(
        '/pages/userCenter/userCenter?r=' +
        '/eCommerce/pages/transferPage/transferPage' +
        '&id=' +
        this.data.transferConfig.vipcard_id +
        '&is_no_condition_recv=' +
        1 +
        '&franchisee=' +
        this.data.franchisee
      )
    })
  }
  recvVipCard = () => {
    app.sendRequest({
      data: {
        vipcard_id: this.data.transferConfig.vipcard_id,
        sub_shop_app_id: this.data.franchisee
      },
      url: '/index.php?r=AppVipCard/RecvVipCard',
      hideLoading: true,
      success: res => {
        app.showToast({
          title: '开卡成功',
          icon: 'success'
        })
        this.data.transferConfig.combine_benefit_enable == 1
          ? this.calulateTransferOrderPrice()
          : this.calculateTotalPrice()
        this.setData({
          'vipCardInfo.isShow': false
        })
      }
    })
  }
  getCollectUserinfoConfig = callback => {
    app.sendRequest({
      data: {},
      url: '/index.php?r=AppVipCard/GetCollectUserinfoConfig',
      hideLoading: true,
      success: res => {
        if (res.data.need_collect_info) {
          callback()
        } else {
          this.recvVipCard()
        }
      }
    })
  }
  showMemberDiscount = e => {
    let memberDiscount = []
    let selectedBenefit = {}
    let combineBenefit = this.data.combineBenefit
    let type = e.currentTarget.dataset.type
    if (type === 'vip') {
      memberDiscount.push({
        label: 'vip',
        value: combineBenefit.all_vip_benefit
      })
      selectedBenefit = {
        type: 'combine',
        discount_type: combineBenefit.selected_user_vip.type || 'vip',
        vip_id: combineBenefit.selected_user_vip.id || 0,
        no_use_benefit:
          combineBenefit.vip_benefit_discount_price === '0.00' ? 1 : 0
      }
    } else if (type === 'coupon') {
      if (!combineBenefit.coupon_benefit) {
        combineBenefit.coupon_benefit = []
      }
      memberDiscount.push({
        label: 'coupon',
        value: combineBenefit.coupon_benefit.concat(
          combineBenefit.cant_use_coupon_benefit || []
        )
      })
      selectedBenefit = {
        type: 'combine',
        discount_type: 'coupon',
        coupon_id: combineBenefit.selected_user_coupon_id,
        no_use_benefit:
          combineBenefit.coupon_benefit_discount_price === '0.00' ? 1 : 0
      }
    } else if (type === 'integral') {
      memberDiscount.push({
        label: 'integral',
        value:
          combineBenefit.integral_benefit instanceof Array
            ? combineBenefit.integral_benefit
            : [combineBenefit.integral_benefit]
      })
      selectedBenefit = {
        type: 'combine',
        discount_type: 'integral',
        no_use_benefit:
          combineBenefit.integral_benefit.discount_price === '0.00' ? 1 : 0
      }
    } else {
      memberDiscount = this.data.memberDiscount
      selectedBenefit = this.data.selectedBenefit
    }
    this.setData({
      memberDiscount: memberDiscount,
      selectedBenefit: selectedBenefit
    })
    this.memberDiscountRef.current.show({
      discountType: memberDiscount,
      franchisee: this.data.franchisee,
      themeColor: this.data.transferConfig.background_color,
      afterSelectedDiscount: (event) => {
        this.afterSelectedBenefit(event)
      }
    });
    this.memberDiscountRef.current.showDialog(this.data.selectedBenefit, this.data.franchisee);
  }
  inputPrice = e => {
    let re = /^\d{1,5}(\.\d{0,2})?$/,
      isShowPriceLimitTip = false,
      price =
        e.target.value.split('¥').length === 2
          ? e.target.value.split('¥')[1]
          : e.target.value
    price = price.replace(/\s+/g, '')
    if (!re.test(price) && price !== '') {
      app.showToast({
        title: '价格区间仅支持0.01~99999.99元',
        icon: 'none',
        duration: 1000
      })
      price = this.data.oldInputPrice
      isShowPriceLimitTip = true
    }
    this.setData({
      inputState: 0,
      storeState: true,
      selectedBenefit: {},
      combineBenefit: {},
      oldInputPrice: price,
      inputPrice: price,
      isShowPriceLimitTip: isShowPriceLimitTip,
      noJoinPrice: +price < +this.data.noJoinPrice ? '' : this.data.noJoinPrice,
      oldNoJoinPrice:
        +price < +this.data.oldNoJoinPrice ? '' : this.data.oldNoJoinPrice
    })
    if (price == 0) {
      let timer = setInterval(() => {
        if (!this.data.requesting && this.data.inputPrice == 0) {
          this.resetData()
          clearInterval(timer)
        } else if (!this.data.requesting && this.data.inputPrice != 0) {
          clearInterval(timer)
        }
      }, 10)
      return
    }
    if (this.data.transferConfig.combine_benefit_enable == 1) {
      this.resetCombineEnable()
      this.calulateTransferOrderPrice()
    } else {
      this.calculateTotalPrice({})
    }
  }
  noJoinPriceInput = e => {
    let re = /^\d{1,5}(\.\d{0,2})?$/,
      price =
        e.target.value.split('¥').length === 2
          ? e.target.value.split('¥')[1]
          : e.target.value
    price = price.replace(/\s+/g, '')
    if (!re.test(price)) {
      price = ''
    }
    if (!+this.data.inputPrice) {
      price = this.data.oldNoJoinPrice
      app.showToast({
        title: '请先输入消费金额',
        icon: 'none',
        duration: 1000
      })
    } else if (+price >= +this.data.inputPrice) {
      price = this.data.oldNoJoinPrice
      app.showToast({
        title: '需小于消费金额',
        icon: 'none',
        duration: 1000
      })
    }
    this.setData({
      storeState: true,
      selectedBenefit: {},
      combineBenefit: {},
      noJoinPrice: price,
      oldNoJoinPrice: price
    })
    this.data.transferConfig.combine_benefit_enable == 1
      ? this.calulateTransferOrderPrice()
      : this.calculateTotalPrice({})
  }
  priceBlur = e => {
    let price =
      e.target.value.split('¥').length === 2
        ? e.target.value.split('¥')[1]
        : e.target.value
    let type = e.currentTarget.dataset.type
    let dataSet = {}
    if (typeof +price === 'number') {
      price = (+price).toFixed(2)
    }
    if (type === 'price') {
      dataSet = { inputPrice: price }
    } else if (type === 'no-join-price') {
      dataSet = { noJoinPrice: price }
    }
    this.setData(dataSet)
  }
  confirmPay = () => {
    let inputPrice = this.data.inputPrice,
      totalPayment = this.data.totalPayment,
      selected_store_benefit = {},
      selected_combination_benefit = {},
      benefits = this.data.selectedBenefit,
      relatedOrderInfo = this.data.relatedOrderInfo
    let { combine_benefit_enable } = this.data.transferConfig
    if (this.data.requesting) {
      return
    }
    this.setData({ requesting: true })
    if (isNaN(inputPrice) || (+inputPrice).toFixed(2) <= 0) {
      app.showModal({
        content: '请输入正确的金额'
      })
      this.setData({ requesting: false })
      return
    }
    if (isNaN(totalPayment) || totalPayment < 0) {
      alertTip('error payment amount')
      this.setData({ requesting: false })
      return
    }
    if (this.data.storeState && this.data.storeBenefitInfo.discount_price) {
      selected_store_benefit = this.data.storeBenefitInfo
    }
    if (this.data.inputState !== 2) {
      selected_combination_benefit = this.filterCombinationBenefit()
    }
    let params = {
      price: inputPrice,
      least_cost: this.data.noJoinPrice,
      check_price: totalPayment,
      message: this.data.remark,
      goods_type: 5,
      sub_shop_app_id: this.data.franchisee
    }
    if (this.data.inputState === 2) {
      params = Object.assign(params, {
        selected_benefit: relatedOrderInfo.selected_benefit_info,
        is_balance: +relatedOrderInfo.use_balance ? 1 : 0
      })
    } else {
      params = Object.assign(params, {
        selected_benefit: combine_benefit_enable == 1 ? '' : benefits,
        selected_store_benefit:
          combine_benefit_enable == 1 ? '' : selected_store_benefit,
        is_balance: this.data.balanceState ? 1 : 0,
        selected_combination_benefit:
          combine_benefit_enable == 1 ? selected_combination_benefit : ''
      })
    }
    if (this.data.relatedData.order_id) {
      params.scan_code_order_id = this.data.relatedData.order_id
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/createTransferOrder',
      method: 'post',
      data: params,
      success: res => {
        var orderId = res.data
        this.payOrder(orderId)
      },
      fail: () => {
        this.setData({ requesting: false })
      }
    })
  }
  filterCombinationBenefit = () => {
    let benefit = this.data.combineBenefit,
      combineEnable = this.data.combineEnable
    benefit.use_balance = +this.data.useBalancePrice
    benefit.total_price = +this.data.totalPayment
    benefit.total_discount_price = +this.data.totalDiscountPrice
    if (combineEnable.vip === 0) {
      delete benefit.vip_benefit
    }
    if (combineEnable.coupon === 0) {
      delete benefit.coupon_benefit
      delete benefit.selected_user_coupon_id
    } else if (combineEnable.coupon === 1) {
      let selectedCouponBenefit = {}
      benefit.coupon_benefit.map(val => {
        if (val.user_coupon_id == benefit.selected_user_coupon_id) {
          selectedCouponBenefit = val
        }
      })
      if (selectedCouponBenefit.user_coupon_id) {
        benefit.coupon_benefit = selectedCouponBenefit
      }
    }
    if (combineEnable.integral === 0) {
      delete benefit.integral_benefit
    }
    if (!this.data.storeState) {
      delete benefit.store_benefit
    }
    return benefit
  }
  payOrder = orderId => {
    let _this = this
    function paySuccess() {
      var pagePath =
        '/eCommerce/pages/transferPaySuccess/transferPaySuccess?detail=' +
        orderId +
        '?franchisee=' +
        _this.data.franchisee
      _this.setData({ requesting: false })
      app.turnToPage(pagePath, 1)
    }
    function payFail() {
      _this.setData({ requesting: false })
      app.turnToPage(
        '/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail=' +
        orderId,
        1
      )
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: res => {
          paySuccess()
        },
        fail: () => {
          payFail()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: res => {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.goodsType = 5
    //     param.success = paySuccess
    //     param.fail = payFail
    //     app.wxPay(param)
    //   },
    //   fail: function () {
    //     this.setData({ requesting: false })
    //   }
    // })
    app.goPay({
      orderId: orderId,
      successUrl: '/transferPaySuccess?detail=' + orderId + '?franchisee=' + _this.data.franchisee,
      failUrl: '/transferOrderDetail?detail=' + orderId,
      cancel: payFail
    })
    this.setData({ requesting: false });
  }
  calculateTotalPrice = (selectedBenefit = this.data.selectedBenefit) => {
    // 计算唯一优惠
    if (+this.data.inputPrice === 0) {
      return
    }
    this.calculateReqNum++
    let price = +this.data.inputPrice,
      calculateReqNum = this.calculateReqNum
    this.setData({
      requesting: true
    })
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: {
        price: price,
        selected_benefit: selectedBenefit,
        is_balance: this.data.balanceState ? 1 : 0,
        not_use_store_benefit: this.data.storeState ? 0 : 1,
        sub_shop_app_id: this.data.franchisee,
        least_cost: +this.data.noJoinPrice
      },
      success: res => {
        let data = res.data,
          benefits = data.can_use_benefit,
          aloneBenefitState = 0,
          selectedBenefit = {},
          transferConfig = this.data.transferConfig,
          memberDiscount = [],
          isShowBalanceItem = false,
          totalDiscountCutPrice =
            data.total_discount_cut_price | data.discount_cut_price,
          {
            coupon_benefit,
            cant_use_coupon_benefit,
            all_vip_benefit,
            integral_benefit
          } = benefits
        if (this.calculateReqNum !== calculateReqNum) {
          return
        }
        this.calculateReqNum = 0
        if (+price === 0) {
          this.setData({
            selectedBenefit: {},
            useBalancePrice: '0.00',
            totalPayment: '',
            balanceState: false,
            aloneBenefitState: 0,
            'storeBenefitInfo.discount_price': '0.00'
          })
          return
        }
        if (transferConfig.coupon_benefit_enable == 1) {
          if (cant_use_coupon_benefit && cant_use_coupon_benefit.length) {
            benefits.cant_use_coupon_benefit = cant_use_coupon_benefit.map(
              val => {
                val.disabled = true
                return val
              }
            )
          }
          memberDiscount.push({
            label: 'coupon',
            value: coupon_benefit.concat(benefits.cant_use_coupon_benefit || [])
          })
        }
        if (transferConfig.vip_card_benefit_enable == 1) {
          memberDiscount.push({
            label: 'vip',
            value: all_vip_benefit
          })
        }
        if (transferConfig.integral_benefit_enable == 1) {
          memberDiscount.push({
            label: 'integral',
            value:
              integral_benefit instanceof Array
                ? integral_benefit
                : [integral_benefit]
          })
        }
        if (benefits.data.length) {
          memberDiscount.map(val => {
            if (val.value.length > 0) {
              aloneBenefitState = 1
            }
          })
        }
        if (aloneBenefitState) {
          selectedBenefit = data.selected_benefit_info || {}
          selectedBenefit.discount_cut_price = (
            +data.selected_benefit_info.discount_cut_price || 0
          ).toFixed(2)
        }
        if (!data.store_benefit_info) {
          data.store_benefit_info = { discount_price: '0.00' }
        }
        data.store_benefit_info.discount_price = (+data.store_benefit_info
          .discount_price).toFixed(2)
        data.store_benefit_info.discount_price = (+data.store_benefit_info
          .discount_price).toFixed(2)
        if (price - totalDiscountCutPrice > +data.balance) {
          isShowBalanceItem = true
        }
        this.setData({
          totalPayment: data.price,
          memberDiscount: memberDiscount,
          selectedBenefit: selectedBenefit,
          aloneBenefitState: aloneBenefitState,
          storeBenefitInfo: data.store_benefit_info,
          useBalancePrice: (+data.use_balance).toFixed(2),
          isShowBalanceItem,
          requesting: false
        })
      },
      fail: () => {
        if (this.calculateReqNum !== calculateReqNum) {
          return
        }
        this.calculateReqNum = 0
        this.setData({ requesting: false })
      }
    })
  }
  calulateTransferOrderPrice = () => {
    // 计算多种优惠叠加
    if (+this.data.inputPrice === 0) {
      return
    }
    this.calculateReqNum++
    let price = +this.data.inputPrice,
      combineEnable = this.data.combineEnable,
      calculateReqNum = this.calculateReqNum
    this.setData({
      requesting: true
    })
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppTransferOrder/CalulateTransferOrderPrice',
      method: 'post',
      data: {
        price: price,
        no_use_vip_benefit: combineEnable.vip ? 0 : 1,
        no_use_coupon_benefit: combineEnable.coupon ? 0 : 1,
        no_use_integral_benefit: combineEnable.integral ? 0 : 1,
        selected_user_coupon_id:
          this.data.combineBenefit.selected_user_coupon_id || 0,
        selected_user_vip: this.data.combineBenefit.selected_user_vip || {},
        no_use_balance: this.data.balanceState ? 0 : 1,
        no_use_store_benefit: this.data.storeState ? 0 : 1,
        sub_shop_app_id: this.data.franchisee,
        least_cost: +this.data.noJoinPrice
      },
      success: res => {
        let data = res.data,
          combine_benefit = data.combine_benefit,
          combineState = {
            vip: 0,
            coupon: 0,
            integral: 0
          },
          isShowBalanceItem = false,
          {
            all_vip_benefit,
            vip_benefit,
            coupon_benefit,
            integral_benefit,
            cant_use_coupon_benefit
          } = combine_benefit
        if (this.calculateReqNum !== calculateReqNum) {
          return
        }
        this.calculateReqNum = 0
        if (all_vip_benefit.length && vip_benefit.discount_price) {
          combineState.vip = 1
          combine_benefit.vip_benefit_discount_price = '0.00'
          all_vip_benefit.forEach(val => {
            if (
              val.vip_id == combine_benefit.selected_user_vip.id &&
              val.discount_type == combine_benefit.selected_user_vip.type
            ) {
              combine_benefit.vip_benefit_discount_price = combineEnable.vip
                ? (+val.discount_price).toFixed(2)
                : '0.00'
            }
          })
        }
        if (coupon_benefit.length) {
          combineState.coupon = 1
          combine_benefit.coupon_benefit_discount_price = '0.00'
          coupon_benefit.forEach(val => {
            if (val.user_coupon_id == combine_benefit.selected_user_coupon_id) {
              combine_benefit.coupon_benefit_discount_price = combineEnable.coupon
                ? (+val.discount_price).toFixed(2)
                : '0.00'
            }
          })
        } else {
          combine_benefit.coupon_benefit_discount_price = '0.00'
        }
        if (cant_use_coupon_benefit.length) {
          combine_benefit.cant_use_coupon_benefit = cant_use_coupon_benefit.map(
            val => {
              val.disabled = true
              return val
            }
          )
        }
        if (integral_benefit.max_can_use_integral) {
          combineState.integral = 1
          combine_benefit.integral_benefit.discount_price = combineEnable.integral
            ? (+integral_benefit.discount_price).toFixed(2)
            : '0.00'
        }
        if (!combine_benefit.store_benefit) {
          combine_benefit.store_benefit = { discount_price: '0.00' }
        }
        if (price - data.total_discount_price > +this.data.userInfo.balance) {
          isShowBalanceItem = true
        }
        combine_benefit.store_benefit.discount_price = (+combine_benefit
          .store_benefit.discount_price).toFixed(2)
        this.setData({
          totalPayment: data.total_price,
          totalDiscountPrice: data.total_discount_price,
          combineBenefit: combine_benefit,
          storeBenefitInfo: combine_benefit.store_benefit,
          useBalancePrice: (+data.use_balance).toFixed(2),
          combineState: combineState,
          isShowBalanceItem: isShowBalanceItem,
          requesting: false
        })
      },
      fail: () => {
        if (this.calculateReqNum !== calculateReqNum) {
          return
        }
        this.calculateReqNum = 0
        this.setData({ requesting: false })
      }
    })
  }
  inputRemark = e => {
    this.setData({
      remark: e.target.value
    })
  }
  updateBalanceState = checked => {
    this.setData({
      balanceState: checked
    })
    this.data.transferConfig.combine_benefit_enable == 1
      ? this.calulateTransferOrderPrice()
      : this.calculateTotalPrice()
  }
  updateStoreState = checked => {
    this.setData({
      storeState: checked,
      selectedBenefit: {}
    })
    this.data.transferConfig.combine_benefit_enable == 1
      ? this.calulateTransferOrderPrice()
      : this.calculateTotalPrice()
  }
  getAppShopByPage = () => {
    let franchiseeId = this.data.franchisee
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        sub_shop_app_id: franchiseeId
      },
      hideLoading: true,
      success: res => {
        let newdata = {},
          data = res.data[0]
        newdata['franchiseeInfo'] = data
        newdata['appTitle'] = data.name
        this.setData(newdata)
      }
    })
  }
  afterSelectedBenefit = options => {
    let selectedDiscount = options.selectedDiscount,
      combineEnable = this.data.combineEnable,
      combineBenefit = this.data.combineBenefit
    if (selectedDiscount.type === 'combine') {
      // 自定义优惠
      if (selectedDiscount.discount_type === 'coupon') {
        if (selectedDiscount.no_use_benefit) {
          combineBenefit.selected_user_coupon_id = 0
          combineEnable.coupon = 0
        } else {
          combineBenefit.selected_user_coupon_id = selectedDiscount.coupon_id
          combineEnable.coupon = 1
        }
      } else if (
        selectedDiscount.discount_type === 'vip' ||
        selectedDiscount.discount_type === 'paid_vip' ||
        selectedDiscount.discount_type === 'vip_benefit_day'
      ) {
        if (selectedDiscount.no_use_benefit) {
          combineBenefit.selected_user_vip = {}
          combineEnable.vip = 0
        } else {
          combineBenefit.selected_user_vip = {
            id: selectedDiscount.vip_id,
            type: selectedDiscount.discount_type
          }
          combineEnable.vip = 1
        }
      } else if (selectedDiscount.discount_type === 'integral') {
        combineEnable.integral = selectedDiscount.no_use_benefit ? 0 : 1
      }
      this.setData({
        combineEnable: combineEnable,
        combineBenefit: combineBenefit
      })
    } else {
      // 唯一会员优惠
      this.setData({
        selectedBenefit: selectedDiscount
      })
    }
    this.data.transferConfig.combine_benefit_enable == 1
      ? this.calulateTransferOrderPrice()
      : this.calculateTotalPrice()
  }
  getStoreBenefitActivityList = () => {
    app.sendRequest({
      url: '/index.php?r=AppStoreBenefit/GetStoreBenefitActivityList',
      method: 'post',
      data: {
        sub_shop_app_id: this.data.franchisee
      },
      hideLoading: true,
      success: res => {
        let data = []
        res.data.map(val => {
          val.activity_start_date = val.activity_start_date.substr(0, 16)
          val.activity_end_date = val.activity_end_date.substr(0, 16)
          if (val.expired !== 1) {
            data.push(val)
          }
        })
        this.setData({
          storeBenefitActivityList: data
        })
      }
    })
  }
  getBalanceData = () => {
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppUserBalance',
      hideLoading: true,
      success: res => {
        this.setData({
          'userInfo.balance': (+res.data.balance).toFixed(2)
        })
      }
    })
  }
  scanPaymentCode = () => {
    app.scanCode({
      onlyFromCamera: false,
      success: res => {
        const { path } = res
        const sceneValue = this.getQueryString(path, 'scene')
        this.getSceneData(sceneValue)
      }
    })
  }
  getBalanceInfo = () => {
    let param = {
      ver: '2.2' //版本
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/getStoredItems',
      data: param,
      hideLoading: true,
      success: res => {
        let { status, data } = res
        if (status === 0) {
          data = data.map(item => {
            let discounts = []
            item.g_price = Number(item.g_price)
            item.g_integral = Number(item.g_integral)
            if (item.g_price) {
              discounts.push(item.g_price + '元')
            }
            if (item.g_integral) {
              discounts.push(item.g_integral + '积分')
            }
            if (item.g_vip_card && item.g_vip_card.title) {
              discounts.push(item.g_vip_card.title)
            }
            if (item.g_coupon_list && item.g_coupon_list.length) {
              item.g_coupon_list.forEach(coupon => {
                discounts.push(coupon.num + '张' + coupon.title)
              })
            }
            if (discounts.length) {
              discounts[0] = '赠送' + discounts[0]
            }
            item.discounts = discounts.join('、')
            return item
          })
          this.setData({
            balanceItemInfo: data
          })
        }
      }
    })
  }
  gotoRecharge = e => {
    const index = e.target.dataset.index // 储值的索引
    const balanceItem = this.data.balanceItemInfo[index]
    const param = {
      type: '1',
      stored_id: balanceItem.id,
      form_id: e.target.formId
    }
    app.showModal({
      title: `即将充值${balanceItem.price}元储值`,
      success: res => {
        if (res.confirm) {
          app.sendRequest({
            url: '/index.php?r=AppShop/creatStoredItemOrder',
            data: param,
            hideLoading: true,
            success: res => {
              this.balancePay(res.data)
            }
          })
        }
      }
    })
  }
  balancePay = orderId => {
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   hideLoading: true,
    //   success: res => {
    //     let { data } = res
    //     data = Object.assign(data, {
    //       orderId,
    //       success: () => {
    //         app.showToast({
    //           title: '充值成功'
    //         })
    //       }
    //     })
    //     app.wxPay(data)
    //   }
    // })
    app.goPay({
      orderId: orderId
    })
  }
  getSceneData = scene => {
    const options = { scene, sub_shop_app_id: this.data.franchisee }
    app.sendRequest({
      url: '/index.php?r=AppTransferOrder/GetSceneData',
      data: options,
      hideLoading: true,
      success: res => {
        const { status, data } = res
        if (status === 0 && data.order_id) {
          let {
            original_price,
            total_price,
            not_discount_price,
            related_order_id
          } = data
          if (!data.selected_benefit_info) {
            data.selected_benefit_info = {}
          }
          data.selected_benefit_info.discount_price = (
            +data.selected_benefit_info.discount_price || 0
          ).toFixed(2)
          data.use_balance = (+data.use_balance || 0).toFixed(2)
          data.coupon_fee = (+data.coupon_fee || 0).toFixed(2)
          this.setData({
            relatedData: data,
            inputPrice: (+original_price || 0).toFixed(2),
            noJoinPrice: (+not_discount_price || 0).toFixed(2),
            isShowNoJoinPrice: !!+not_discount_price,
            relatedOrderInfo: data,
            inputState: related_order_id ? 2 : 1
          })
          if (!related_order_id) {
            this.data.transferConfig.combine_benefit_enable == 1
              ? this.calulateTransferOrderPrice()
              : this.calculateTotalPrice()
          } else {
            this.setData({
              totalPayment: (+total_price || 0).toFixed(2)
            })
          }
        }
      }
    })
  }
  getQueryString = (path, name) => {
    if (!path) {
      return ''
    }
    const paramsStr = path.split('?')[1] || ''
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = paramsStr.match(reg)
    if (r != null) return unescape(r[2])
    return ''
  }
  config = {
    navigationBarTitleText: '当面付',
    navigationBarTextStyle: 'black',
    navigationStyle: 'custom'
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      franchiseeIdInfo,
      memberDiscount,
      franchisee,
      transferConfig,
      appTitle,
      storeBenefitActivityList,
      inputPrice,
      inputState,
      isShowPriceLimitTip,
      noJoinPrice,
      currentStoreBenefitInfo,
      storeState,
      storeBenefitInfo,
      vipCardInfo,
      aloneBenefitState,
      selectedBenefit,
      combineState,
      combineBenefit,
      userInfo,
      balanceState,
      useBalancePrice,
      relatedOrderInfo,
      benefitType,
      balanceItemInfo,
      isShowBalanceItem,
      remark,
      totalPayment,
      requesting
    } = this.state
    return (
      <div className="official-page transfer-page">
        <TopNav title="当面付"/>
        <React.Fragment>
          <div className="transfer-wrap">
            <div className="transfer-header">
              <div className="transfer-name">
                付款给<span className="account">{appTitle}</span>
              </div>
              {!!storeBenefitActivityList.length && (
                <div
                  className="coupon-desc"
                  onClick={this.goToCouponDesc}
                  style={convertLineStyleData('color: ' + transferConfig.background_color)}
                >
                  优惠说明
                </div>
              )}
            </div>
            <div className="transfer-input consumption-block">
              <div className="space-between">
                <div className="input-text">消费金额</div>
                <div className="input-price-block">
                  <input
                    value={inputPrice !== '' ? '¥' + inputPrice : ''}
                    className={
                      'input-price ' +
                      (transferConfig.scan_mode == 1 ? 'm-r-40' : '')
                    }
                    placeholder={
                      transferConfig.input_mode === '0' ? '' : '请输入金额'
                    }
                    onChange={this.inputPrice}
                    onBlur={this.priceBlur}
                    disabled={
                      inputState === 1 ||
                      inputState === 2 ||
                      transferConfig.input_mode === '0'
                    }
                    data-type="price"
                  />
                  {transferConfig.scan_mode == 1 && (
                    <span
                      className="ico-moon icon-shopping-scan"
                      onClick={this.scanPaymentCode}
                    ></span>
                  )}
                </div>
              </div>
              {isShowPriceLimitTip && (
                <div className="price-limit">价格区间仅支持0.01~99999.99元</div>
              )}
            </div>
            {transferConfig.scan_mode == 1 && (
              <div className="scan-tip-block">
                <span className="scan-tip">扫码可快速填充</span>
              </div>
            )}
            {/*  (inputState === 1 && transferConfig.scan_least_cost == 1)  */}
            {/*  <checkbox-group 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              class="no-join-checkbox"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              bindchange="isShowNoJoinPriceChange" 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              wx:if="{{ inputState === 0 && transferConfig.least_cost == 1 }}">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <label class="no-join-price">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <checkbox value="noJoinPrice" 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          style={convertLineStyleData('border-color: {{ transferConfig.background_color }}')} 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          checked="{{ isShowNoJoinPrice }}" 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          color="{{ transferConfig.background_color }}" />
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <view class="no-join-text" style={convertLineStyleData('color: {{ transferConfig.background_color }}')}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  输入不参与优惠金额
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </label>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <text class="scan-tip" wx:if="{{ transferConfig.scan_mode == 1 }}">扫码可快速填充</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            </checkbox-group>  */}
            {transferConfig.least_cost == 1 && inputState !== 2 && (
              <div className="transfer-input no-join-block">
                <div className="input-text">不参与金额</div>
                <div className="input-price-block">
                  <input
                    value={noJoinPrice !== '' ? '¥' + noJoinPrice : ''}
                    className="input-price"
                    style={convertLineStyleData('font-size: 32rpx')}
                    placeholder={
                      transferConfig.input_mode === '0' ? '' : '请输入金额'
                    }
                    onChange={this.noJoinPriceInput}
                    onBlur={this.priceBlur}
                    disabled={
                      inputState === 1 ||
                      inputState === 2 ||
                      transferConfig.input_mode === '0'
                    }
                    data-type="no-join-price"
                  />
                </div>
              </div>
            )}
            {inputState !== 2 && (
              <div className="discount-block">
                {currentStoreBenefitInfo.activity_title && (
                  <div className="item space-between store-discount">
                    <span className="store-title">店铺满减</span>
                    <div>
                      <div className="discount-text" hidden={inputPrice}>
                        {currentStoreBenefitInfo.rule_titles.map(
                          (item, index) => {
                            return (
                              <span key={index}>
                                {index === 0 ? item : ', ' + item}
                              </span>
                            )
                          }
                        )}
                      </div>
                      {inputPrice && (
                        <React.Fragment>
                          <Switch
                            checked={storeState}
                            onChange={this.updateStoreState}
                          ></Switch>
                          {storeBenefitInfo.discount_price &&
                            storeBenefitInfo.discount_price != 0 &&
                            storeState && (
                              <div
                                className="discount-price"
                                style={convertLineStyleData(
                                  'color: ' + transferConfig.background_color
                                )}
                              >
                                {'-¥' + storeBenefitInfo.discount_price}
                              </div>
                            )}
                          {storeBenefitInfo.discount_price == 0 && storeState && (
                            <div className="store-tip">不满足满减条件</div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                )}
                {vipCardInfo.isShow && (
                  <div className="item vip-card-block">
                    <div className="vip-card">
                      <img className="card-img" src={vipCardInfo.logo} />
                      <div className="card-info">
                        <div className="card-name">
                          {vipCardInfo.app_name + ' ' + vipCardInfo.title}
                        </div>
                        {vipCardInfo.discount != 0 ? (
                          <div className="card-mess">
                            {'免费开卡享 ' + vipCardInfo.discount + '折'}
                          </div>
                        ) : vipCardInfo.coupon_list &&
                          vipCardInfo.coupon_list != '' ? (
                              <div className="card-mess">免费开卡享 赠送优惠券</div>
                            ) : (
                              vipCardInfo.integral != 0 && (
                                <div className="card-mess">
                                  {'免费开卡享 赠送' + vipCardInfo.integral + '积分'}
                                </div>
                              )
                            )}
                      </div>
                      <div className="card-btn" onClick={this.handleVipCard}>
                        立即开卡
                      </div>
                    </div>
                  </div>
                )}
                {/*  唯一会员优惠  */}
                {!!+aloneBenefitState && (
                  <div
                    className="item space-between member-discount"
                    onClick={this.showMemberDiscount}
                  >
                    <div style={convertLineStyleData('font-size: 28rpx')}>会员优惠</div>
                    <div className="member-discount-detail">
                      {selectedBenefit.discount_cut_price &&
                        selectedBenefit.discount_cut_price !== '0.00' && (
                          <div
                            className="price"
                            style={convertLineStyleData('color: ' + transferConfig.background_color)}
                          >
                            {'-¥' + selectedBenefit.discount_cut_price}
                          </div>
                        )}
                      {selectedBenefit.discount_cut_price &&
                        selectedBenefit.discount_cut_price === '0.00' && (
                          <div
                            className="price"
                            style={convertLineStyleData('color: ' + transferConfig.background_color)}
                          >
                            未使用
                          </div>
                        )}
                      <div className="ico-moon icon-rightarrow"></div>
                    </div>
                  </div>
                )}
                {/*  自定义会员优惠  */}
                {!!+combineState.vip && transferConfig.vip_card_benefit_enable == 1 && (
                  <div
                    className="item member-discount"
                    data-type="vip"
                    onClick={this.showMemberDiscount}
                  >
                    <div style={convertLineStyleData('font-size: 28rpx')}>会员卡优惠</div>
                    <div className="member-discount-detail">
                      {combineBenefit.vip_benefit &&
                        combineBenefit.vip_benefit_discount_price !== '0.00' && (
                          <div
                            className="price"
                            style={convertLineStyleData('color: ' + transferConfig.background_color)}
                          >
                            {'-¥' + combineBenefit.vip_benefit_discount_price}
                          </div>
                        )}
                      {combineBenefit.vip_benefit &&
                        combineBenefit.vip_benefit_discount_price === '0.00' && (
                          <div
                            className="price"
                            style={convertLineStyleData('color: ' + transferConfig.background_color)}
                          >
                            未使用
                          </div>
                        )}
                      <div className="ico-moon icon-rightarrow"></div>
                    </div>
                  </div>
                )}
                {transferConfig.combine_benefit_enable == 1 &&
                  inputPrice &&
                  transferConfig.coupon_benefit_enable == 1 && (
                    <div
                      className="item member-discount"
                      data-type="coupon"
                      onClick={this.showMemberDiscount}
                    >
                      <div style={convertLineStyleData('font-size: 28rpx')}>优惠券减免</div>
                      <div className="member-discount-detail">
                        {combineState.coupon === 1 && (
                          <React.Fragment>
                            {combineBenefit.coupon_benefit_discount_price &&
                              combineBenefit.coupon_benefit_discount_price !==
                              '0.00' && (
                                <div
                                  className="price"
                                  style={convertLineStyleData(
                                    'color: ' + transferConfig.background_color
                                  )}
                                >
                                  {'-¥' +
                                    combineBenefit.coupon_benefit_discount_price}
                                </div>
                              )}
                            {combineBenefit.coupon_benefit_discount_price &&
                              combineBenefit.coupon_benefit_discount_price ===
                              '0.00' && (
                                <div
                                  className="price"
                                  style={convertLineStyleData(
                                    'color: ' + transferConfig.background_color
                                  )}
                                >
                                  未使用
                                </div>
                              )}
                          </React.Fragment>
                        )}
                        {combineState.coupon === 0 && (
                          <React.Fragment>
                            <div
                              className="price"
                              style={convertLineStyleData('color: ' + transferConfig.background_color)}
                            >
                              无可用优惠券
                            </div>
                          </React.Fragment>
                        )}
                        <div className="ico-moon icon-rightarrow"></div>
                      </div>
                    </div>
                  )}
                {!!+combineState.integral &&
                  transferConfig.integral_benefit_enable == 1 && (
                    <div
                      className="item member-discount"
                      data-type="integral"
                      onClick={this.showMemberDiscount}
                    >
                      <div style={convertLineStyleData('font-size: 28rpx')}>积分抵扣</div>
                      <div className="member-discount-detail">
                        {combineBenefit.integral_benefit &&
                          combineBenefit.integral_benefit.discount_price !==
                          '0.00' && (
                            <div
                              className="price"
                              style={convertLineStyleData('color: ' + transferConfig.background_color)}
                            >
                              {'-¥' +
                                combineBenefit.integral_benefit.discount_price}
                            </div>
                          )}
                        {combineBenefit.integral_benefit &&
                          combineBenefit.integral_benefit.discount_price ===
                          '0.00' && (
                            <div
                              className="price"
                              style={convertLineStyleData('color: ' + transferConfig.background_color)}
                            >
                              未使用
                            </div>
                          )}
                        <div className="ico-moon icon-rightarrow"></div>
                      </div>
                    </div>
                  )}
                {transferConfig.use_balance_enable !== '0' &&
                  franchisee === '' &&
                  userInfo.balance &&
                  userInfo.balance != 0 && (
                    <div className="item space-between stored-value-discount">
                      <span style={convertLineStyleData('font-size: 28rpx')}>
                        {'储值抵扣（余额：￥' + userInfo.balance + '）'}
                      </span>
                      <div className="stored-value-block">
                        <Switch
                          onChange={this.updateBalanceState}
                          checked={balanceState}
                        ></Switch>
                        <div
                          className="stored-value-price"
                          hidden={!balanceState || useBalancePrice == 0}
                          style={convertLineStyleData('color: ' + transferConfig.background_color)}
                        >
                          {'-¥' + useBalancePrice}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            )}
            {/*  关联订单优惠  */}
            {inputState === 2 && (
              <div className="discount-block">
                {relatedOrderInfo.selected_benefit_info.discount_type && (
                  <div className="item member-discount">
                    <div style={convertLineStyleData('font-size: 28rpx')}>
                      {benefitType[
                        relatedOrderInfo.selected_benefit_info.discount_type
                      ] + '优惠'}
                    </div>
                    <div className="member-discount-detail">
                      <div
                        className="price"
                        style={convertLineStyleData('color: ' + transferConfig.background_color)}
                      >
                        {'-¥' +
                          relatedOrderInfo.selected_benefit_info.discount_price}
                      </div>
                    </div>
                  </div>
                )}
                {relatedOrderInfo.use_balance !== '0.00' && (
                  <div className="item member-discount">
                    <div style={convertLineStyleData('font-size: 28rpx')}>储值抵扣</div>
                    <div className="member-discount-detail">
                      <div
                        className="price"
                        style={convertLineStyleData('color: ' + transferConfig.background_color)}
                      >
                        {'-¥' + relatedOrderInfo.use_balance}
                      </div>
                    </div>
                  </div>
                )}
                {relatedOrderInfo.coupon_fee !== '0.00' && (
                  <div className="item member-discount">
                    <div style={convertLineStyleData('font-size: 28rpx')}>社交立减金</div>
                    <div className="member-discount-detail">
                      <div
                        className="price"
                        style={convertLineStyleData('color: ' + transferConfig.background_color)}
                      >
                        {'-¥' + relatedOrderInfo.coupon_fee}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {isShowBalanceItem &&
              balanceItemInfo.length &&
              transferConfig.use_balance_enable !== '0' &&
              inputState !== 2 &&
              franchisee === '' && (
                <div className="balance-block">
                  <div className="title">储值优惠</div>
                  {balanceItemInfo.length === 1 && (
                    <React.Fragment>
                      <div className="detail">
                        {balanceItemInfo.map((item, index) => {
                          return (
                            <div
                              className="balance-item-first"
                              key={index}
                              style={convertLineStyleData(
                                'border-color: ' + transferConfig.background_color
                              )}
                            >
                              <div
                                className="price"
                                style={convertLineStyleData(
                                  'color: ' + transferConfig.background_color
                                )}
                              >
                                {'￥' + item.price}
                              </div>
                              <div className="discount-wrapper">
                                <div className="discount-item">
                                  {item.discounts}
                                </div>
                              </div>
                              <form className="balance-form">
                                <button
                                  className="pay-btn"
                                  type="button"
                                  data-index={index}
                                  onClick={this.gotoRecharge}
                                  style={convertLineStyleData(
                                    'background-color: ' +
                                    transferConfig.background_color
                                  )}
                                >
                                  立即充值
                                </button>
                              </form>
                            </div>
                          )
                        })}
                      </div>
                    </React.Fragment>
                  )}
                  {balanceItemInfo.length > 1 && (
                    <React.Fragment>
                      <ScrollView scroll-x="true" className="balance-scroll">
                        {balanceItemInfo.map((item, index) => {
                          return (
                            <div
                              className="balance-item-second"
                              key={index}
                              style={convertLineStyleData(
                                'border-color: ' +
                                transferConfig.background_color +
                                '; width: ' +
                                (balanceItemInfo.length === 2
                                  ? '258rpx'
                                  : '216rpx')
                              )}
                            >
                              <div className="price-block">
                                <div
                                  className="price"
                                  style={convertLineStyleData(
                                    'color: ' + transferConfig.background_color
                                  )}
                                >
                                  {'￥' + item.price}
                                </div>
                                <div className="discount-wrapper">
                                  <div className="discount-item">
                                    {item.discounts}
                                  </div>
                                </div>
                              </div>
                              <form className="balance-form">
                                <button
                                  className="pay-btn"
                                  type="button"
                                  data-index={index}
                                  onClick={this.gotoRecharge}
                                  style={convertLineStyleData(
                                    'color: ' +
                                    transferConfig.background_color +
                                    ';'
                                  )}
                                >
                                  立即充值
                                </button>
                              </form>
                            </div>
                          )
                        })}
                      </ScrollView>
                    </React.Fragment>
                  )}
                </div>
              )}
            <div className="transfer-input remark">
              <div className="input-text">备注</div>
              <input
                style={convertLineStyleData('font-size: 28rpx; text-overflow: ellipsis;')}
                maxLength="30"
                placeholder="请填写备注信息"
                onChange={this.inputRemark}
              />
            </div>
            <button
              className="submit-btn"
              disabled={totalPayment === '' || requesting}
              onClick={this.confirmPay}
              style={convertLineStyleData('background: ' + transferConfig.background_color)}
            >
              {(totalPayment === '' ? '' : totalPayment + '元  ') + '确认支付'}
            </button>
          </div>
        </React.Fragment>
        <MemberDiscount ref={this.memberDiscountRef} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/transfer-page/TransferPage.jsx